module.exports = __webpack_public_path__ + "static/img/5.5760e60.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/team/5.jpg
// module id = CxFh
// module chunks = 0